;(function () {
  angular
    .module('contrast.onboarding.setup')
    .controller('onboardingSetupCtrl', onboardingSetupCtrl)

  function onboardingSetupCtrl($scope, UserService) {
    'ngInject'

    angular.extend($scope, {
      model: {
        breakdown: {},
        orgID: '',
        appID: ''
      }
    })

    function setModelProps() {
      $scope.model.breakdown = UserService.getSetupSteps()
      $scope.model.orgID = UserService.getCurrentOrganizationId()
      $scope.model.appID = UserService.getSampleApplicationID()
    }

    $scope.$on('setups:loaded', function () {
      setModelProps()
    })
  }
})()
